import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@common/hooks';
import Filters from 'works/legacy/lib/filters';
import { ApplicationsList } from './applications-list';
import { CandidatesList } from './candidates-list';
import { ErrorHandler } from '@common/components';

const DEFAULT_PAGE_SIZE = 10;
const TAB_STATES_MAP = {
  submitted: ['submitted', 'submittal_packet_change_requested', 'in_review'],
  offers: ['offered'],
};

// @TODO: refactor this component to avoid gql query switching in runtime - WORK-6053
export function CollectionFetcher({ tab, staffingRequest }) {
  const CollectionComponent =
    tab === 'not_submitted' ? CandidatesList : ApplicationsList;
  const defaultFilters =
    tab === 'not_submitted' ? Filters.getFilters('CandidatesList') : {};

  let paginationAttrs = {
    limit: DEFAULT_PAGE_SIZE,
    staffingRequestId: staffingRequest.id,
  };

  const handleTableChange = (pagination, filters) => {
    const paginationPageSize = pagination.pageSize || DEFAULT_PAGE_SIZE;

    paginationAttrs['offset'] = (pagination.current - 1) * paginationPageSize;
    paginationAttrs['limit'] = paginationPageSize;
    paginationAttrs['pageSize'] = paginationPageSize;

    fetchMore({
      variables: {
        ...paginationAttrs,
        filters: filters,
      },
      updateQuery: (_prev, { fetchMoreResult }) => {
        return fetchMoreResult;
      },
    });
  };

  const { loading, error, data, fetchMore } = useQuery(
    CollectionComponent.fragments.query,
    {
      variables: {
        staffingRequestId: staffingRequest.id,
        limit: 10,
        offset: 0,
        orderField: 'STATUS_CHANGED_AT',
        orderDirection: 'DESC',
        states: TAB_STATES_MAP[tab] || tab,
        staffingRequestStartDate: staffingRequest.startDate,
        staffingRequestEndDate: staffingRequest.endDate,
        organizationId: staffingRequest.organization.id,
        organizationBusinessId: staffingRequest.organizationBusiness.id,
        organizationUnitId: staffingRequest.organizationUnit.id,
        filters: defaultFilters,
      },
    }
  );

  if (error) {
    return <ErrorHandler error={error} log="CollectionFetcher" />;
  }

  if (data && data.paginatedRecords)
    paginationAttrs['total'] = data.paginatedRecords.totalCount;

  return (
    <CollectionComponent
      staffingRequest={staffingRequest}
      loading={loading}
      fetchMore={fetchMore}
      data={data ? data.paginatedRecords : {}}
      paginationAttrs={paginationAttrs}
      handleTableChange={handleTableChange}
    />
  );
}

CollectionFetcher.propTypes = {
  tab: PropTypes.string.isRequired,
  staffingRequest: PropTypes.shape({
    id: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    organization: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    organizationBusiness: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    organizationUnit: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
